import axios from 'axios'

// URL base dell'API per le fasi delle iniziative, recuperato dall'env file

const FASI_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'iniziativa-fasi'

const headers = { 'Content-Type': 'application/json' }

class IniziativaFasiService {
    /**
     * Aggiorna le fasi delle iniziative.
     * Effettua una richiesta POST a `/iniziative-fasi/save` inviando i dati aggiornati.
     *
     * @param {Object} iniziativa - Oggetto contenente le informazioni sulle fasi dell'iniziativa'.
     * @returns {Promise} - Una promessa che restituisce la risposta del server.
     */
    aggiornaFasi(iniziativa) {
        return axios.post(FASI_REST_API_URL + "/save", iniziativa, { headers });
    }
     /**
     * Elimina le fasi specifiche che vengono passate.
     * Effettua una richiesta POST a `/iniziativa-fasi/delete` con un array di oggetti da eliminare.
     *
     * @param {Array<Object>} fasi - Lista delle fasi da eliminare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server.
    */
    eliminaFasi(fasi) {
        return axios.post(FASI_REST_API_URL + "/delete", fasi, { headers });
    }
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const iniziativaFasiServiceInstance = new IniziativaFasiService();
export default iniziativaFasiServiceInstance;